import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsFieldModel } from './widgets-field.model';

export class WidgetsCheckboxModel extends WidgetsFieldModel {
  readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.CHECKBOX;
  name: string = 'Checkbox';
  readonly badge: string = 'O';

  // Additional fields
  required: boolean = true;
  // otherFlag: boolean = false;
  // otherMaxLength?: number;
  // otherLabel?: string;
  // otherKey?: string;
  // otherDescription?: string;
  commentFieldOn?: string;            // Primitive has conditional comment - Additional comment field version
  isExtended: boolean = true;         // Checkboxes are extended by default
  commentFieldOff? : string;

  toJSON(): any {
    const extendedSpecificProperties = {
      required: this.required ? this.required : undefined,
      commentFieldOn: this.commentFieldOn ? this.commentFieldOn : undefined,
      commentFieldOff: this.commentFieldOff ? this.commentFieldOff : undefined,  
      // otherFlag: this.otherFlag ? this.otherFlag : undefined,
      // otherKey: this.otherKey ? this.otherKey : undefined,
      // otherLabel: this.otherLabel ? this.otherLabel : undefined,
      // otherMaxLength: this.otherMaxLength ? this.otherMaxLength : undefined,
      // otherDescription: this.otherDescription ? this.otherDescription : undefined,      
      isExtended: this.isExtended ? this.isExtended : undefined,
    };

    const fieldProperties = super.toJSON();
    return { ...fieldProperties, ...extendedSpecificProperties };
  }

  /**
   * Clone from a provided origin.
   *
   * @note Id/uuid is not cloned
   * @note Without children.
   * @param origin
   * @returns
   */
  cloneFrom(origin: WidgetsCheckboxModel): WidgetsCheckboxModel {
    // Clone base class
    super.cloneFrom(origin);

    // Clone extended class specific properties
    this.required = origin.required;
    // if (origin.otherFlag) {
    //   this.otherFlag = origin.otherFlag;
    // }
    // if (origin.otherKey) {
    //   this.otherKey = origin.otherKey;
    // }    
    // if (origin.otherLabel) {
    //   this.otherLabel = origin.otherLabel;
    // }
    // if (origin.otherDescription) {
    //   this.otherDescription = origin.otherDescription;
    // }    
    // if (origin.otherMaxLength) {
    //   this.otherMaxLength = origin.otherMaxLength;
    // }
    if (origin.commentFieldOn) {
      this.commentFieldOn = origin.commentFieldOn;
    }
    if (origin.commentFieldOff) {
      this.commentFieldOff = origin.commentFieldOff;
    }
    if (origin.isExtended) {
      this.isExtended = origin.isExtended;
    }
    return this;
  }
}
